(() => {
  const TEMPLATE_ID = 'faf-product-card-loading-template';
  const SKELETON_ATTR = 'data-faf-load-more-skeleton';
  const SKELETON_SELECTOR = `[${SKELETON_ATTR}]`;
  const PLACEHOLDER_COUNT = 8;

  let observer = null;
  let baselineProductCount = 0;

  const productList = () => document.getElementById('productList');

  const clearSkeletons = () => {
    observer?.disconnect();
    observer = null;

    document
      .querySelectorAll(SKELETON_SELECTOR)
      .forEach((element) => element.remove());
  };

  const currentMaxOrder = (list) => Array.from(list.children).reduce(
    (maximum, element) => {
      const order = Number.parseInt(element.style.order || '0', 10);
      return Number.isFinite(order) ? Math.max(maximum, order) : maximum;
    },
    0
  );

  const appendSkeletons = () => {
    const list = productList();
    const template = document.getElementById(TEMPLATE_ID);

    if (!list || !template || document.querySelector(SKELETON_SELECTOR)) {
      return;
    }

    baselineProductCount = list.querySelectorAll('.faf-product-card-render').length;
    const baseOrder = currentMaxOrder(list) + 1;

    for (let index = 0; index < PLACEHOLDER_COUNT; index += 1) {
      const fragment = template.content.cloneNode(true);
      const skeleton = fragment.querySelector('[data-faf-product-card-skeleton]');

      if (!skeleton) continue;

      skeleton.removeAttribute('data-faf-product-card-skeleton');
      skeleton.setAttribute(SKELETON_ATTR, '');
      skeleton.style.order = String(baseOrder + index);
      list.appendChild(fragment);
    }

    observer?.disconnect();
    observer = new MutationObserver(() => {
      const nextCount = list.querySelectorAll('.faf-product-card-render').length;

      if (nextCount > baselineProductCount) {
        clearSkeletons();
      }
    });

    observer.observe(list, { childList: true });
  };

  window.addEventListener('load-more', appendSkeletons);
  window.addEventListener('load-more-complete', clearSkeletons);
  window.addEventListener('pagehide', clearSkeletons);
})(); 
